exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content,.modal-dialog{max-width:100%!important;max-height:100%!important;width:100%;height:100%;padding:0;margin:0}", ""]);

// exports
